var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"bottom":"","right":"","multi-line":"","timeout":6000},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }